import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { Component, Inject, OnInit } from '@angular/core';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { ReportForAccountingDaysInMonthInfo, ReportForAccountingViewInfo } from '../model/reportForAccounting.model';
import { ProjectInfo } from '../model/project.model';
import { SimpleTextInfo } from '../model/simpleTextInfo.model';
import { LookupInfo } from '../model/lookup.model';
import { EffortPlanInfo } from '../model/effortplan.model';
import { JobInfo } from '../model/Job.model';
import { EmpInfo } from '../model/emp.model';
import { ReportEffortPlanProjectInfo } from '../model/reportEffortPlanProject.model';
import { DatePipe, formatDate } from '@angular/common';
import { now } from 'jquery';
import { debug } from 'console';

@Component({
  selector: 'app-project-plan-actual-compare-report',
  templateUrl: './project-plan-actual-compare-report.component.html',
  styleUrls: ['./project-plan-actual-compare-report.component.css']
})
export class ProjectPlanActualCompareReportComponent implements OnInit {

  baseurl: string;

  //Primary data
  ListEffortPlan: EffortPlanInfo[] = [];
  ReportView: ReportEffortPlanProjectInfo[];
  ListPosition: JobInfo[] = [];
  selectEmpName: EmpInfo[] = [];
  selectProj: ProjectInfo[] = [];

  //ListMonth: { id: number, monthYear: string }[] = [];
  ListMonth = [];

  //Search Conditions
  ListProjectCode: string[] = [];
  minEffortMonthYear: string | null = null;

  txtSchProject: string = "";
  txtSchProjectCode: string = "";
  txtSchProjectName: string = "";
  txtSchYear: string = "";
  txtSchYearTo: string = "";
  txtSchFormat: string = "1";
  txtSchFormatCurrent: string = "1";

  txtSubmittedProject: ProjectInfo[] = [];
  txtSubmittedYear: string = "";

  isSearchSubmitted: boolean = false;

  //Export
  fileName = 'TestSheet.xlsx';

  //empselect
  projectselectrun: boolean = false;
  selectedproject: ProjectInfo[] = [];

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;

    GlobalService.CheckPagingAccessRights();
  }

  // ngOnInit - start
  // ========================================================================================================
  ngOnInit(): void {

  }
  // ngOnInit - end
  // ========================================================================================================

  // OnEvent - start
  // ========================================================================================================
  OnSearch_Click() {
    // if(!this.txtSchEmployee || !this.txtSchYear) {
    //   alert("Please select employee and year before submit")
    //   return;
    // }

    if (!this.txtSchYear) {
      alert('Please select as of month')
      return;
    };

    this.isSearchSubmitted = true;
    this.txtSchFormatCurrent = this.txtSchFormat;

    this.LoadReport();
    this.LoadPosition().then((data) => {
      this.ListPosition = data;
    });


    this.txtSubmittedProject = this.selectedproject
    this.txtSubmittedYear = this.txtSchYear
  }

  OnClearSearch_Click() {
    this.txtSchYear = null;
    this.txtSchYearTo = null;
    this.txtSchFormat = "1";
    this.txtSchProject = null;
    this.txtSchProjectCode = "";
    this.txtSchProjectName = "";
    this.selectedproject = [];
    this.ListEffortPlan = null;
    this.ReportView = [];
    this.isSearchSubmitted = false;
  }

  //func
  getPlanDayByEmpMonth(filteredListEffortPlan, EmployeeIndex, MonthDate) {
    let res = 0

    //debugger

    if (filteredListEffortPlan[EmployeeIndex].ListEffort == null || this.ListEffortPlan[EmployeeIndex].ListEffort.length <= 0) return res;

    let target = filteredListEffortPlan[EmployeeIndex];

    let xs = target.ListEffort.filter(x => formatDate(new Date(x.EffortMonthYear), 'MMM yyyy', 'en-US') == formatDate(new Date(MonthDate), 'MMM yyyy', 'en-US') )[0];

    if (xs == null) return res;

    res = xs.EffortManDay;

    return res;
  }

  getPlanDayByMonth(filteredListEffortPlan, MonthDate) {
    let res = 0

    //debugger

    for (var i = 0; i < filteredListEffortPlan.length; i++) {
      if (filteredListEffortPlan[i].ListEffort == null || this.ListEffortPlan[i].ListEffort.length <= 0) continue;

      let target = filteredListEffortPlan[i];

      let xs = target.ListEffort.filter(x => formatDate(new Date(x.EffortMonthYear), 'MMM yyyy', 'en-US') == formatDate(new Date(MonthDate), 'MMM yyyy', 'en-US'))[0];

      if (xs == null) continue;

      res += xs.EffortManDay;
    }


    return res;
  }

  OnExport_Click() {
    //let element = document.getElementById('checkbox-select');
    //const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    ///* generate workbook and add the worksheet */
    //const wb: XLSX.WorkBook = XLSX.utils.book_new();

    //XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    ///* save to file */
    //XLSX.writeFile(wb, this.fileName);

    console.log(this.ListMonth)

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet("By Detail");//formatDate(this.txtSchYear, 'MMM-yyyy', 'en-US')

    
    worksheet.mergeCells('A1:I1');
    // Title
    let sdate = (this.txtSchYearTo == null || this.txtSchYearTo == '') ? formatDate(this.txtSchYear, 'MMM yyyy', 'en-US') : formatDate(this.txtSchYear, 'MMM', 'en-US') + ' - ' + formatDate(this.txtSchYearTo, 'MMM yyyy', 'en-US')

    let title = 'Plan & Actual Comparison (From ' + sdate + ')';

    // Add new row
    // Set the value and alignment for the custom title
    const titleCell = worksheet.getCell('A1');
    titleCell.value = title;
    //titleCell.alignment = { horizontal: 'center', vertical: 'middle' };

    //define workdays for months
    worksheet.mergeCells('A2:I2');
    let aboveheader = 'Printed Date: ' + formatDate(new Date(), 'dd MMM yyyy', 'en-US');
    // Add new row
    // Set the value and alignment for the custom title
    const aboveheaderCell = worksheet.getCell('A2');
    aboveheaderCell.value = aboveheader;
    //aboveheaderCell.alignment = { horizontal: 'center', vertical: 'middle' };

    //Project Detail

    let header = ["Project Code", "Project Name", "Company", "Project Role", "Employee", " ", "Month", "Total"];
    let headerMonth = [];
    // merge by start row, start column, end row, end column


    //define months header
    
    for (let month of this.ListMonth) {
      headerMonth.push(month.monthYear);
    }
    // Concatenate the extra column to the header
    //headerMonth.push("");

    //Add Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.font = { bold: true };

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      }
    });

    worksheet.mergeCells(worksheet.rowCount, 1, worksheet.rowCount + 1, 1);//projectcode
    worksheet.mergeCells(worksheet.rowCount - 1, 2, worksheet.rowCount, 2);//project name
    worksheet.mergeCells(worksheet.rowCount - 1, 3, worksheet.rowCount, 3);//company name
    worksheet.mergeCells(worksheet.rowCount - 1, 4, worksheet.rowCount, 4);//project role
    worksheet.mergeCells(worksheet.rowCount - 1, 5, worksheet.rowCount, 5);//emp
    worksheet.mergeCells(worksheet.rowCount - 1, 6, worksheet.rowCount, 6);//blank
    worksheet.mergeCells(worksheet.rowCount - 1, 7, worksheet.rowCount - 1, 7 + this.ListMonth.length - 1);//month
    worksheet.mergeCells(worksheet.rowCount - 1, 7 + this.ListMonth.length, worksheet.rowCount, 7 + this.ListMonth.length);//total
    let total = worksheet.getCell(worksheet.rowCount - 1, 7 + this.ListMonth.length)
    total.value = 'Total';
    total.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFFFFF00' },
      bgColor: { argb: 'FF0000FF' }
    }
    total.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    total.alignment = {
      vertical: 'middle',
      horizontal: 'center'
    }

    debugger

    for (let index in headerMonth) {
      let monthcell = worksheet.getCell(worksheet.rowCount, 7 + Number(index));
      monthcell.value = headerMonth[index];
      monthcell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      monthcell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      monthcell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      }
      monthcell.font = { bold: true };
    }


    //Main Data Array
    let exportData = [];

    console.log(this.ListEffortPlan)

    //Parsing and adding
    let distinctProjCode = Array.from(new Set(this.ListEffortPlan.map((item: any) => item.ProjectSaleCode)));

    distinctProjCode.sort((a, b) => {
      return a.ProjectSaleCode < b.ProjectSaleCode
        ? 1
        : -1
    })

    //proj loop
    for (let j = 0; j < distinctProjCode.length; j++) {

      let filteredListEffortPlan = this.ListEffortPlan.filter(x => x.ProjectSaleCode == distinctProjCode[j]);

      let curproj = '';

      for (let i = 0; i < filteredListEffortPlan.length; i++) {

        let newRow = [];

        if (curproj != distinctProjCode[j]) {
          newRow.push(filteredListEffortPlan[i].ProjectSaleCode);
          newRow.push(filteredListEffortPlan[i].ProjectSaleName);
          newRow.push(filteredListEffortPlan[i].CompanyName);
        } else {
          newRow.push("");
          newRow.push("");
          newRow.push("");
        }
        
        newRow.push(filteredListEffortPlan[i].EffortPlanProjectRole);
        newRow.push(filteredListEffortPlan[i].EffortPlanEmpName);
        newRow.push("Plan");

        curproj = distinctProjCode[j];

        let newActual = [];

        newActual.push("");
        newActual.push("");
        newActual.push("");
        newActual.push("");
        newActual.push("");
        newActual.push("Actual");

        let newRemained = [];

        newRemained.push("");
        newRemained.push("");
        newRemained.push("");
        newRemained.push("");
        newRemained.push("");
        newRemained.push("Remained");

        let newProgress = [];

        newProgress.push("");
        newProgress.push("");
        newProgress.push("");
        newProgress.push("");
        newProgress.push("");
        newProgress.push("Progress (%)");

        let tolPlan = 0;
        let tolAct = 0;
        let tolRem = 0;

        for (let mth of this.ListMonth) {
          let plan = this.getPlanDayByEmpMonth(filteredListEffortPlan, i.toString(), mth.monthYearDB)
          let act = this.getActualEmployeeWorkhoursByMonth(filteredListEffortPlan[i], mth.monthYearDB)

          if (plan == null) plan = 0;
          if (act == null) act = 0;

          let rem = plan - act

          if (plan == 0 && act == 0) {
            newRow.push('')
            newActual.push('')
            newRemained.push('')
            newProgress.push('')
          } else {
            newRow.push(plan.toFixed(1))
            newActual.push(act.toFixed(1))
            newRemained.push(rem.toFixed(1))

            let xproc = plan > 0 ? ((act * 100) / plan).toFixed(1) : '-';

            newProgress.push(xproc)
          }

          

          

          tolPlan += plan;
          tolAct += act;
          tolRem += rem;
        }
        //const actualTotal = this.getActualEmployeeWorkhoursTotal(i.toString());
        //const planTotal = this.getEmployeeWorkhoursTotal(i.toString());
        const progress = (tolAct * 100) / tolPlan;

        newRow.push(tolPlan.toFixed(1));
        newActual.push(tolAct.toFixed(1));
        newRemained.push(tolRem.toFixed(1));
        newProgress.push(progress.toFixed(1));

        exportData.push(newRow)
        exportData.push(newActual)
        exportData.push(newRemained)
        exportData.push(newProgress)
      }



      //summary proj

      let newRow = [];

      newRow.push(filteredListEffortPlan[0].ProjectSaleCode);
      newRow.push(filteredListEffortPlan[0].ProjectSaleName);
      newRow.push(filteredListEffortPlan[0].CompanyName);
      newRow.push("");
      newRow.push("");
      newRow.push("Plan");

      let newActual = [];

      newActual.push("");
      newActual.push("");
      newActual.push("");
      newActual.push("");
      newActual.push("");
      newActual.push("Actual");

      let newRemained = [];

      newRemained.push("");
      newRemained.push("");
      newRemained.push("");
      newRemained.push("");
      newRemained.push("");
      newRemained.push("Remained");

      let newProgress = [];

      newProgress.push("");
      newProgress.push("");
      newProgress.push("");
      newProgress.push("");
      newProgress.push("");
      newProgress.push("Progress (%)");


      let tolPlan = 0;
      let tolAct = 0;
      let tolRem = 0;

      for (let mth of this.ListMonth) {

        //if plan exist, actual not => display 0
        //if plan not exist, display -
        //if plan - actual equal negative => display red
        //progress = actualx100/plan, if negative show red, beyond to show -
        //if to > than exist delivery, show blank

        let plan = this.getPlanDayByMonth(filteredListEffortPlan, mth.monthYearDB)
        let act = this.getActualWorkhoursByMonth(filteredListEffortPlan, mth.monthYearDB)

        if (plan == null) plan = 0;
        if (act == null) act = 0;

        let rem = plan - act

        if (plan == 0 && act == 0) {
          newRow.push('')
          newActual.push('')
          newRemained.push('')
          newProgress.push('')
        } else {
          newRow.push(plan.toFixed(1))
          newActual.push(act.toFixed(1))
          newRemained.push(rem.toFixed(1))

          let xproc = plan > 0 ? ((act * 100) / plan).toFixed(1) : '-';

          newProgress.push(xproc)
        }

        tolPlan += plan;
        tolAct += act;
        tolRem += rem;
      }
      //const actualTotal = this.getActualEmployeeWorkhoursTotal(i.toString());
      //const planTotal = this.getEmployeeWorkhoursTotal(i.toString());
      const progress = (tolAct * 100) / tolPlan;

      newRow.push(tolPlan.toFixed(1));
      newActual.push(tolAct.toFixed(1));
      newRemained.push(tolRem.toFixed(1));
      newProgress.push(progress.toFixed(1));

      exportData.push(newRow)
      exportData.push(newActual)
      exportData.push(newRemained)
      exportData.push(newProgress)

    }

    
    // Add Data and Conditional Formatting
    exportData.forEach(d => {
      let row = worksheet.addRow(d);

      //for (let month of this.ListMonth) {

      //  row.

      //}

      //let qty = row.getCell(5);
      //let color = 'FF99FF99';
      //if (+qty.value < 500) {
      //  color = 'FF9999'
      //}

      //qty.fill = {
      //  type: 'pattern',
      //  pattern: 'solid',
      //  fgColor: { argb: color }
      //}

      row.eachCell((cell, number) => {

        if (number > 6) {
          let text = Number(cell.text);

          let color = '';
          if (text < 0) {
            color = 'FF0000'
            cell.value = '('+Math.abs(text)+')'
          }
          //if (percent < 79) {
          //  color = 'FF0000'
          //}

          if (color != '') {
            cell.font = { color: { argb: color } }
          }

          cell.alignment = { horizontal: 'right', vertical: 'middle' }
        }

        
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }

        if ((!isNaN(Number(cell.value))) && (cell.value != '' && cell.value != null)) {
          cell.value = (cell.value != '-') ? Number(cell.value).toFixed(1) : cell.value;
        }
      });
    });

    // Define Footer Data
    //let footer = ["", ""];
    //for (let month of this.ListMonth) {
    //  footer.push(this.getEmployeeWorkhoursByMonthTotalRaw(month));
    //}

    //Add Footer Row
    //let footerRow = worksheet.addRow(footer);

    //footerRow.font = { bold: true };
    //footerRow.eachCell((cell, number) => { cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } } });

    // Blank Row between Summary
    worksheet.addRow([]);

    //let totalemp = this.ListEmployeeCode.length;
    //let submitcomplete = 0;
    //let submitincomplete = 0;
    //let notsubmit = 0;

    //for (let emp of this.ListEmployeeCode) {
    //  let status = this.getEmployeeWorkhoursTotalStatusRaw(emp);

    //  if (status == 'COMPLETE') submitcomplete++;
    //  if (status == 'INCOMPLETE') submitincomplete++;
    //  if (status == 'NOTSUBMIT') notsubmit++;
    //}

    //// Define Summary Rows
    //let totalempRow = ["", "Total Employees", this.ListEmployeeCode.length]
    //let submitcompleteRow = ["", "Submitted Complete", submitcomplete]
    //let submitincompleteRow = ["", "Submitted Incomplete", submitincomplete]
    //let notsubmitRow = ["", "Not-Submitted", notsubmit]

    //let summaryrows = [];
    //summaryrows.push(totalempRow)
    //summaryrows.push(submitcompleteRow)
    //summaryrows.push(submitincompleteRow)
    //summaryrows.push(notsubmitRow)

    //// Add Summary Rows
    //summaryrows.forEach(d => {
    //  let row = worksheet.addRow(d);

    //  let rowhead = row.getCell(2);
    //  let rowvalue = row.getCell(3);

    //  rowhead.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    //  rowvalue.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    //});

    
    let worksheet2 = workbook.addWorksheet("By Project");//formatDate(this.txtSchYear, 'MMM-yyyy', 'en-US')


    worksheet2.mergeCells('A1:I1');
    // Title
    let sdate2 = (this.txtSchYearTo == null || this.txtSchYearTo == '') ? formatDate(this.txtSchYear, 'MMM yyyy', 'en-US') : formatDate(this.txtSchYear, 'MMM', 'en-US') + ' - ' + formatDate(this.txtSchYearTo, 'MMM yyyy', 'en-US')

    let title2 = 'Plan & Actual Comparison (From ' + sdate + ')';

    // Add new row
    // Set the value and alignment for the custom title
    const titleCell2 = worksheet2.getCell('A1');
    titleCell2.value = title2;
    //titleCell.alignment = { horizontal: 'center', vertical: 'middle' };

    //define workdays for months
    worksheet2.mergeCells('A2:I2');
    let aboveheader2 = 'Printed Date: ' + formatDate(new Date(), 'dd MMM yyyy', 'en-US');
    // Add new row
    // Set the value and alignment for the custom title
    const aboveheaderCell2 = worksheet2.getCell('A2');
    aboveheaderCell2.value = aboveheader2;
    //aboveheaderCell.alignment = { horizontal: 'center', vertical: 'middle' };

    //Project Detail

    let header2 = ["Project Code", "Project Name", "Company", "Project Role", "Employee", " ", "Month", "Total"];
    let headerMonth2 = [];
    // merge by start row, start column, end row, end column


    //define months header

    for (let month of this.ListMonth) {
      headerMonth2.push(month.monthYear);
    }
    // Concatenate the extra column to the header
    //headerMonth.push("");

    //Add Header Row
    let headerRow2 = worksheet2.addRow(header2);
    headerRow2.font = { bold: true };

    // Cell Style : Fill and Border
    headerRow2.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      }
    });

    worksheet2.mergeCells(worksheet2.rowCount, 1, worksheet2.rowCount + 1, 1);//projectcode
    worksheet2.mergeCells(worksheet2.rowCount - 1, 2, worksheet2.rowCount, 2);//project name
    worksheet2.mergeCells(worksheet2.rowCount - 1, 3, worksheet2.rowCount, 3);//company name
    worksheet2.mergeCells(worksheet2.rowCount - 1, 4, worksheet2.rowCount, 4);//project role
    worksheet2.mergeCells(worksheet2.rowCount - 1, 5, worksheet2.rowCount, 5);//emp
    worksheet2.mergeCells(worksheet2.rowCount - 1, 6, worksheet2.rowCount, 6);//blank
    worksheet2.mergeCells(worksheet2.rowCount - 1, 7, worksheet2.rowCount - 1, 7 + this.ListMonth.length - 1);//month
    worksheet2.mergeCells(worksheet2.rowCount - 1, 7 + this.ListMonth.length, worksheet2.rowCount, 7 + this.ListMonth.length);//total
    let total2 = worksheet2.getCell(worksheet2.rowCount - 1, 7 + this.ListMonth.length)
    total2.value = 'Total';
    total2.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFFFFF00' },
      bgColor: { argb: 'FF0000FF' }
    }
    total2.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    total2.alignment = {
      vertical: 'middle',
      horizontal: 'center'
    }

    debugger

    for (let index in headerMonth2) {
      let monthcell = worksheet2.getCell(worksheet2.rowCount, 7 + Number(index));
      monthcell.value = headerMonth2[index];
      monthcell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      monthcell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      monthcell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      }
      monthcell.font = { bold: true };
    }


    //Main Data Array
    let exportData2 = [];

    //Parsing and adding
    let distinctProjCode2 = Array.from(new Set(this.ListEffortPlan.map((item: any) => item.ProjectSaleCode)));

    //proj loop
    for (let j = 0; j < distinctProjCode2.length; j++) {

      let filteredListEffortPlan = this.ListEffortPlan.filter(x => x.ProjectSaleCode == distinctProjCode[j]);

      //summary proj

      let newRow = [];

      newRow.push(filteredListEffortPlan[0].ProjectSaleCode);
      newRow.push(filteredListEffortPlan[0].ProjectSaleName);
      newRow.push(filteredListEffortPlan[0].CompanyName);
      newRow.push("");
      newRow.push("");
      newRow.push("Plan");

      let newActual = [];

      newActual.push("");
      newActual.push("");
      newActual.push("");
      newActual.push("");
      newActual.push("");
      newActual.push("Actual");

      let newRemained = [];

      newRemained.push("");
      newRemained.push("");
      newRemained.push("");
      newRemained.push("");
      newRemained.push("");
      newRemained.push("Remained");

      let newProgress = [];

      newProgress.push("");
      newProgress.push("");
      newProgress.push("");
      newProgress.push("");
      newProgress.push("");
      newProgress.push("Progress (%)");

      let tolPlan = 0;
      let tolAct = 0;
      let tolRem = 0;

      for (let mth of this.ListMonth) {

        //if plan exist, actual not => display 0
        //if plan not exist, display -
        //if plan - actual equal negative => display red
        //progress = actualx100/plan, if negative show red, beyond to show -
        //if to > than exist delivery, show blank

        let plan = this.getPlanDayByMonth(filteredListEffortPlan, mth.monthYearDB)
        let act = this.getActualWorkhoursByMonth(filteredListEffortPlan, mth.monthYearDB)

        if (plan == null) plan = 0;
        if (act == null) act = 0;

        let rem = plan - act

        if (plan == 0 && act == 0) {
          newRow.push('')
          newActual.push('')
          newRemained.push('')
          newProgress.push('')
        } else {
          newRow.push(plan.toFixed(1))
          newActual.push(act.toFixed(1))
          newRemained.push(rem.toFixed(1))

          let xproc = plan > 0 ? ((act * 100) / plan).toFixed(1) : '-';

          newProgress.push(xproc)
        }

        tolPlan += plan;
        tolAct += act;
        tolRem += rem;
      }
      //const actualTotal = this.getActualEmployeeWorkhoursTotal(i.toString());
      //const planTotal = this.getEmployeeWorkhoursTotal(i.toString());
      const progress = (tolAct * 100) / tolPlan;

      newRow.push(tolPlan.toFixed(1));
      newActual.push(tolAct.toFixed(1));
      newRemained.push(tolRem.toFixed(1));
      newProgress.push(progress.toFixed(1));

      exportData2.push(newRow)
      exportData2.push(newActual)
      exportData2.push(newRemained)
      exportData2.push(newProgress)

    }


    // Add Data and Conditional Formatting
    exportData2.forEach(d => {
      let row = worksheet2.addRow(d);

      //for (let month of this.ListMonth) {

      //  row.

      //}

      //let qty = row.getCell(5);
      //let color = 'FF99FF99';
      //if (+qty.value < 500) {
      //  color = 'FF9999'
      //}

      //qty.fill = {
      //  type: 'pattern',
      //  pattern: 'solid',
      //  fgColor: { argb: color }
      //}

      row.eachCell((cell, number) => {

        if (number > 6) {
          let text = Number(cell.text);

          let color = '';
          if (text < 0) {
            color = 'FF0000'
            cell.value = '('+Math.abs(text)+')'
          }
          //if (percent < 79) {
          //  color = 'FF0000'
          //}

          if (color != '') {
            cell.font = { color: { argb: color } }
          }

          cell.alignment = { horizontal: 'right', vertical: 'middle' }
        }

        
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }

        if ((!isNaN(Number(cell.value))) && (cell.value != '' && cell.value != null)) {
          cell.value = (cell.value != '-') ? Number(cell.value).toFixed(1) : cell.value;
        }
      });
    });


    // Write out file
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'PROJECT-PLAN-ACTUAL-COMPARE-REPORT-' + formatDate(this.txtSchYear, 'ddMMyyyy', 'en-US') + '.xlsx');
    });

    
  }
  // OnEvent - end
  // ========================================================================================================

  // Primary-Data Functions - start
  // ========================================================================================================
  async LoadReport() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      //objectjson["EffortGroupId"] = this._ParamEffortGroupId;
      //objectjson['ProjectSaleCode'] = this.txtSchProjectCode;
      objectjson['ListProject'] = this.selectedproject;
      objectjson['ProjectType'] = "DELIVERY";
      objectjson['SearchAsOfDate'] = this.checkUndefinedString(this.txtSchYear) ? this.txtSchYear + '-01' : null;
      objectjson['SearchFormat'] = this.checkUndefinedString(this.txtSchFormat) ? this.txtSchFormat : "1";

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<EffortPlanInfo[]>(this.baseurl + "EffortGroup/GetEffortPlan", strjson, httpOptions)
        .toPromise()
        .then((data) => {
          this.ListEffortPlan = data;
          this.ListMonth = this.getMaxMonth()
          // Iterate through ListEffortPlan
          this.ListEffortPlan.forEach((effortPlan) => {
            // Iterate through ListEffort of each EffortPlan
            effortPlan.ListEffort.forEach((effortInfo) => {
              // Check if EffortMonthYear is missing
              if (!effortInfo.EffortMonthYear) {
                // Find the matching ListMonth item based on id
                const matchingMonth = this.ListMonth.find((month) => month.id === effortInfo.EffortMonth);

                // If a matching month is found, add EffortMonthYear
                if (matchingMonth) {
                  effortInfo.EffortMonthYear = matchingMonth.monthYear;
                }
              }

              const effortMonthYear = effortInfo.EffortMonthYear;
              if (!this.minEffortMonthYear || (effortMonthYear && effortMonthYear < this.minEffortMonthYear)) {
                this.minEffortMonthYear = effortMonthYear;
              }
              if(this.ListEffortPlan){
                this.LoadActualEffort().then((data) => {
                  this.ReportView = data;
                });
                this.loadEmp();
              }
            });
          });
          
        });
    }
  }



  async LoadPosition() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<JobInfo[]>(this.baseurl + "Job/GetJob", strjson, httpOptions)
        .toPromise()
    }
  }

  async loadEmp() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.selectEmpName = data;
          this.selectEmpName.map(o => {
            o.emp_label =
              ` ${o.EmpCode} - ${o.EmpName_TH}
          `
            return o
          });
        });

    }
  }

  async LoadActualEffort() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //this.Loading(true, 'Loading...');

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      // Initialize an array of EmpInfo objects
      this.selectEmpName = [];

      // Create and populate EmpInfo objects with EffortPlanEmpCode values
      this.ListEffortPlan.forEach(effortPlan => {
        const empInfo: EmpInfo = {
          EmpCode: effortPlan.EffortPlanEmpCode,
          Id: 0,
          EmpCodeValidate: '',
          EmpName: '',
          Username: '',
          Password: '',
          AgentId: '',
          Title_TH: '',
          Title_Name: '',
          EmpFname_TH: '',
          EmpLname_TH: '',
          EmpName_TH: '',
          EmpName_EN: '',
          Title_EN: '',
          EmpFname_EN: '',
          EmpLname_EN: '',
          EmpType: '',
          EmpTypeName: '',
          JobCode: '',
          JobTitle: '',
          CompanyCode: '',
          CompanyName: '',
          Mobile: '',
          PositionCode: 0,
          PositionName: '',
          ActiveFlag: '',
          Mail: '',
          EntryDate: '',
          UpdateDate: '',
          UpdateBy: '',
          CreateDate: '',
          CreateBy: '',
          ExpireDate: '',
          LoginEmpCode: '',
          FlagDelete: '',
          LookupValue: '',
          countEmp: 0,
          rowOFFSet: 0,
          rowFetch: 0,
          RoleCode: '',
          RoleName: '',
          DepartmentCode: '',
          UnitCode: '',
          TeamCode: '',
          TeamName: '',
          NickName: '',
          CountProjectCreateBy: 0,
          PercentProjectSalebyEmp: 0,
          IsTeam: false,
          ImgProfile: '',
          Token: '',
          RefreshToken: '',
          BirthDate: '',
          Gender: '',
          GenderName: '',
          OrganizationCode: '',
          emp_label: '',
          ResignDate: '',
          BaseArea: '',
          DivisionCode: '',
          DivisionName: '',
          lJobTitle: [],
          ProjectCode: ''
        };

        // Push the created EmpInfo object into the selectEmpName array
        this.selectEmpName.push(empInfo);
      });


      debugger

      let searchproj = this.selectedproject;

      if (this.selectedproject == null || this.selectedproject.length <= 0) {
        let distinctProjCode = Array.from(new Set(this.ListEffortPlan.map((item: any) => item.ProjectSaleCode)))

        let listProj: ProjectInfo[] = [];

        for (var i = 0; i < distinctProjCode.length; i++) {
          let itemA = new ProjectInfo();
          itemA.ProjectCode = distinctProjCode[i];
          listProj.push(itemA)
        }

        searchproj = listProj;
      }

      var objectjson = {};
      objectjson['SearchEmployeeCode'] = this.selectEmpName;
      objectjson['SearchAsOfDate'] = null;// this.ListEffortPlan.map(list => list.ListEffort.map(item => item.EffortMonthYear));
      objectjson['SearchFormat'] = this.checkUndefinedString(this.txtSchFormat) ? this.txtSchFormat : "1";
      objectjson['SearchListProjectCode'] = searchproj;

      console.log(this.txtSchYear)

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient
        .post<ReportEffortPlanProjectInfo[]>(this.baseurl + "ProjectEffortPlan/GetReportActualSummary",
          strjson, httpOptions)
        .toPromise()
    }
  }


  // Primary-Data Functions - end
  // ========================================================================================================


  // Misc functions - start
  // ========================================================================================================
  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }


  replaceCommas(number) {
    var result = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    //if (result.indexOf('.') < 0) {
    //  result += ".00";
    //}

    return result;
  }

  // Misc functions - end
  // ========================================================================================================


  selectedProject(event) {
    console.log("SELECTED PROJECT")

    this.selectedproject = event;
    console.log(this.selectedproject)

  }

  projectselect() {
    this.projectselectrun = true;
    this.txtSchProject = ""
    this.txtSchProjectCode = ""
    this.txtSchProjectName = ""
    this.selectedproject = [];
    this.ListEffortPlan = null;
    this.isSearchSubmitted = false;

    $('#ModalProjectSelect').modal();
  }

  async saveProjectSelect() {

    $('#ModalProjectSelect').modal('hide');
    this.projectselectrun = false;

    this.txtSchProject = this.selectedproject.length + ' project(s) selected';
    //this.txtSchProjectCode = this.selectedproject[0].ProjectCode;
    //this.txtSchProjectName = this.selectedproject[0].ProjectName;

    this.txtSchProjectCode = this.selectedproject.map(x => x.ProjectCode).join(",")
    this.txtSchProjectName = this.selectedproject.map(x => x.ProjectName).join(",")

  }

  getEmployeeName(EmpCode: string) {
    return this.ReportView.filter(x => x.EmployeeCode == EmpCode)[0].EmployeeDisplay;
  }

  //// Calculat Effort Man Hours
  getMonthYearString(date: Date): string {
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${month}-${year}`;
  }

  getMonthYearDB(date: Date): string {
    const monthNames = [
      '01', '02', '03', '04', '05', '06',
      '07', '08', '09', '10', '11', '12'
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${year}-${month}-01`;
  }

  monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }

  getMaxMonth() {

    this.ListMonth = [];

    let maxce = 0;
    let ceil = [];
    //for (let i of this.ListEffortPlan) {
    //  //let max = Array.from(new Set(i.ListEffort.map((item: any) => item.EffortMonth)));

    //  //if (max.length > ceil.length) ceil = max;

    //  let des = i.ListEffort.sort((a, b) => {
    //    return a.EffortMonth < b.EffortMonth
    //      ? 1
    //      : -1
    //  })

    //  if (des[0].EffortMonth > maxce) maxce = des[0].EffortMonth;

    //}

    debugger

    const defaultStartDate = new Date(this.minEffortMonthYear);

    const StartDate = this.txtSchYear ? new Date(this.txtSchYear) : new Date(formatDate(defaultStartDate, 'yyyy-MMM', 'en-US'));

    if (this.txtSchYearTo != null && this.txtSchYearTo != '') {
      const EndDate = new Date(this.txtSchYearTo);

      maxce = this.monthDiff(StartDate, EndDate) + 1;
    } else {
      const EndDate = new Date(new Date(this.txtSchYear).getFullYear()+'-12-01');

      maxce = this.monthDiff(StartDate, EndDate) + 1;
    }


    for (let v = 1; v <= maxce; v++) {
      ceil.push(v)
      const date = new Date(StartDate.getFullYear(), StartDate.getMonth() - 1 + v, 1);
      const monthYearString = this.getMonthYearString(date);
      const monthYearDB = this.getMonthYearDB(date);
      this.ListMonth.push({ id: v, monthYear: monthYearString, monthYearDB: monthYearDB });
    }

    return this.ListMonth;
  }

  getEmployeeWorkhoursTotal(EmployeeIndex: string) {

    let res = 0

    if (this.ListEffortPlan[EmployeeIndex].ListEffort == null || this.ListEffortPlan[EmployeeIndex].ListEffort.length <= 0) return res;

    let rec = this.ListEffortPlan[EmployeeIndex].ListEffort;

    if (rec != null && rec.length > 0) res = rec.reduce((sum, current) => sum + current.EffortManDay, 0)// * 8;

    return res;
  }

  getActualEmployeeWorkhoursTotal(PlanIndex: string) {
    //need fix
    let res = 0;

    if (this.ListEffortPlan[PlanIndex].ListEffort == null || this.ListEffortPlan[PlanIndex].ListEffort.length <= 0) {
      return res;
    }

    const rec = this.ListEffortPlan[PlanIndex].ListEffort;

    //for (let r of rec) {
    for (let mth of this.ListMonth) {
      const workHoursTotal = this.getActualEmployeeWorkhoursByMonthLegacy(PlanIndex.toString(), mth.monthYearDB);
      res += workHoursTotal;
    }
    //}

    return res;
  }

  getActualEmployeeWorkhoursByMonth(filteredListEffortPlan, MonthSeq: string) {
    let rec = 0;

    // Extract the Year-Month portion of the strings
    const yearMonth = MonthSeq.substring(0, 7);

    // Check if ReportView is null or undefined
    if (this.ReportView) {
      // Use Array.isArray to ensure ReportView is an array before filtering
      if (Array.isArray(this.ReportView)) {
        // Filter the ReportView array based on the condition
        const filteredData = this.ReportView.filter(x => x.EmployeeCode == filteredListEffortPlan.EffortPlanEmpCode && x.ProjectCode == filteredListEffortPlan.ProjectSaleCode && x.TimeSheetDate.substring(0, 7) == yearMonth);

        if (filteredData != null && filteredData.length > 0) {
          // Calculate the sum of 'Hours' in the filtered data
          rec = filteredData.reduce((sum, current) => sum + current.Hours, 0);
        }
      }
    }

    return rec;
  }

  getActualEmployeeWorkhoursByMonthLegacy(effortplanindex, MonthSeq: string) {
    let rec = 0;

    // Extract the Year-Month portion of the strings
    const yearMonth = MonthSeq.substring(0, 7);

    // Check if ReportView is null or undefined
    if (this.ReportView) {
      // Use Array.isArray to ensure ReportView is an array before filtering
      if (Array.isArray(this.ReportView)) {
        // Filter the ReportView array based on the condition
        const filteredData = this.ReportView.filter(x => x.EmployeeCode == this.ListEffortPlan[effortplanindex].EffortPlanEmpCode && x.ProjectCode == this.ListEffortPlan[effortplanindex].ProjectSaleCode && x.TimeSheetDate.substring(0, 7) == yearMonth);

        if (filteredData != null && filteredData.length > 0) {
          // Calculate the sum of 'Hours' in the filtered data
          rec = filteredData.reduce((sum, current) => sum + current.Hours, 0);
        }
      }
    }

    return rec;
  }

  getActualWorkhoursByMonth(filteredListEffortPlan, MonthSeq: string) {
    let rec = 0;

    debugger
    // Extract the Year-Month portion of the strings
    const yearMonth = MonthSeq.substring(0, 7);

    console.log(this.ReportView)

    // Check if ReportView is null or undefined
    if (this.ReportView) {
      // Use Array.isArray to ensure ReportView is an array before filtering
      if (Array.isArray(this.ReportView)) {
        // Filter the ReportView array based on the condition
        const filteredData = this.ReportView.filter(x => x.TimeSheetDate.substring(0, 7) == yearMonth && x.ProjectCode == filteredListEffortPlan[0].ProjectSaleCode);

        if (filteredData != null && filteredData.length > 0) {
          // Calculate the sum of 'Hours' in the filtered data
          rec = filteredData.reduce((sum, current) => sum + current.Hours, 0);
        }
      }
    }

    //console.log('result for ' + filteredListEffortPlan[0].ProjectSaleCode+ ' - ' + yearMonth + ' - ' + rec)

    return rec;
  }

}
